var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcnBlockAds(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 99.488,
    height: 99.171,
    viewBox: "0 0 99.488 99.171",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "circle",
    x: 0,
    y: 0,
    width: 99.488,
    height: 99.171,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.078
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn-block-ads",
    transform: "translate(9 6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#circle)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "circle-2",
    "data-name": "circle",
    cx: 40.744,
    cy: 40.586,
    rx: 40.744,
    ry: 40.586,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "dots",
    transform: "translate(-0.373 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16132",
    "data-name": "Group 16132",
    transform: "translate(-33 -21)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1262",
    "data-name": "Ellipse 1262",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    transform: "translate(56.15 88.221)",
    fill: "#e7e6e6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1263",
    "data-name": "Ellipse 1263",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    transform: "translate(47.443 36.88)",
    fill: "#8c94c9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1264",
    "data-name": "Ellipse 1264",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    transform: "translate(41.611 59.432)",
    fill: "#97d3f1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16131",
    "data-name": "Group 16131",
    transform: "translate(-22 -14)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1265",
    "data-name": "Ellipse 1265",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    transform: "translate(81.357 79.38)",
    fill: "#8c94c9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1266",
    "data-name": "Ellipse 1266",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    transform: "translate(89.932 47.762)",
    fill: "#97d3f1"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1267",
    "data-name": "Ellipse 1267",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    transform: "translate(62.533 16.227)",
    fill: "#e7e6e6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "icn",
    transform: "translate(-1294.709 -48.951)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16606",
    "data-name": "Group 16606",
    transform: "translate(-2.861 -2.248)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12296",
    "data-name": "Path 12296",
    d: "M0,0A6.867,6.867,0,0,0,2.125,3.769c2.182,2.254,2.758,2.014,8,1.746,5.672-.292,13.6,3.054,14.4,4.872H.016S-.009.084,0,0Z",
    transform: "translate(1332.57 76.477) rotate(90)",
    fill: "#00aafc",
    opacity: 0.045
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12303",
    "data-name": "Path 12303",
    d: "M0,0S.142,1.127,2.125,2.469c2.182,1.477,2.758,1.319,8,1.144,5.672-.191,13.6,2,14.4,3.192H.016S-.009.055,0,0Z",
    transform: "translate(1327.376 76.477) rotate(90)",
    fill: "#00aafc",
    opacity: 0.045
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_12412",
    "data-name": "Path 12412",
    d: "M1222.758,15.6h-6.264c-.206,0-.373-.352-.373-.786s.167-.786.373-.786h6.264c.206,0,.373.352.373.786S1222.964,15.6,1222.758,15.6Z",
    transform: "translate(136.463 54.11)",
    fill: "#00aafc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12314",
    "data-name": "Path 12314",
    d: "M1224.011,15.6h-7.446c-.245,0-.444-.352-.444-.786s.2-.786.444-.786h7.446c.245,0,.444.352.444.786S1224.256,15.6,1224.011,15.6Z",
    transform: "translate(89.481 82.58)",
    fill: "#00aafc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12411",
    "data-name": "Path 12411",
    d: "M1232.973,19.581h-6.9c-.206,0-.373-.352-.373-.787s.167-.785.373-.785h6.9c.206,0,.373.352.373.785S1233.179,19.581,1232.973,19.581Z",
    transform: "translate(131.745 53.371)",
    fill: "#00aafc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12315",
    "data-name": "Path 12315",
    d: "M1234.346,19.581h-8.2c-.245,0-.444-.352-.444-.787s.2-.785.444-.785h8.2c.245,0,.444.352.444.785S1234.591,19.581,1234.346,19.581Z",
    transform: "translate(85.682 81.84)",
    fill: "#00aafc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "pc",
    transform: "translate(-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17129",
    "data-name": "Rectangle 17129",
    width: 36,
    height: 24,
    rx: 1,
    transform: "translate(1320.709 72.951)",
    fill: "none",
    stroke: "#347cb5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1093",
    "data-name": "Line 1093",
    x2: 20,
    transform: "translate(1328.709 104.951)",
    fill: "none",
    stroke: "#347cb5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1094",
    "data-name": "Line 1094",
    y2: 8,
    transform: "translate(1332.709 96.951)",
    fill: "none",
    stroke: "#347cb5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1095",
    "data-name": "Line 1095",
    y2: 8,
    transform: "translate(1344.709 96.951)",
    fill: "none",
    stroke: "#347cb5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17005",
    "data-name": "Group 17005",
    transform: "translate(-652.429 -178.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12896",
    "data-name": "Path 12896",
    d: "M700.974,217.853a7.688,7.688,0,0,0,.761-2.766c-.3,0-.589.006-.877,0a.581.581,0,0,1-.556-.8.564.564,0,0,1,.548-.366c.284,0,.568,0,.853-.006.005,0,.01-.007.038-.025a7.575,7.575,0,0,0-.718-2.766c-.279.161-.543.318-.812.466a.575.575,0,0,1-.711-.109.567.567,0,0,1-.067-.7.843.843,0,0,1,.247-.227c.235-.147.479-.281.719-.42a.41.41,0,0,0,.041-.034,7.773,7.773,0,0,0-2.033-2.058c-.162.279-.315.554-.478.823a.58.58,0,1,1-1.007-.578c.151-.276.311-.547.476-.835a7.648,7.648,0,0,0-2.816-.76c0,.29,0,.565,0,.84a1.183,1.183,0,0,1-.031.318.565.565,0,0,1-.639.386.559.559,0,0,1-.483-.528c-.011-.271,0-.543-.005-.815,0-.061,0-.122,0-.2a7.607,7.607,0,0,0-2.815.758c.166.29.329.566.483.847a.549.549,0,0,1-.051.639.5.5,0,0,1-.588.2.874.874,0,0,1-.385-.3c-.174-.245-.309-.518-.467-.791a7.83,7.83,0,0,0-2.041,2.066c.261.151.513.294.762.44a.586.586,0,1,1-.585,1.008c-.236-.134-.471-.27-.707-.4-.01-.005-.024,0-.057,0a7.594,7.594,0,0,0-.71,2.772h.848a.586.586,0,1,1,.007,1.168c-.265,0-.531,0-.8.005-.011,0-.022.009-.049.021a7.684,7.684,0,0,0,.758,2.741c.249-.143.482-.278.716-.41a.584.584,0,1,1,.581,1.009c-.228.135-.458.265-.724.419.254.3.483.612.745.888a7.645,7.645,0,0,0,4.292,2.312c.385.069.6.3.586.621a.581.581,0,0,1-.7.546,8.818,8.818,0,0,1-5.471-3.19,7.19,7.19,0,0,1-.772-1.075,9.1,9.1,0,0,1-1-2.587,8.78,8.78,0,0,1,2.648-8.495,8.421,8.421,0,0,1,4.956-2.318,8.855,8.855,0,0,1,9.312,5.353,8.926,8.926,0,0,1-6.276,12.222c-.147.035-.3.063-.445.089a.583.583,0,0,1-.689-.444.561.561,0,0,1,.454-.693,8.429,8.429,0,0,0,2.208-.711,7.715,7.715,0,0,0,2.928-2.526c-.244-.142-.48-.283-.718-.418a.579.579,0,0,1-.319-.463.58.58,0,0,1,.857-.57C700.458,217.552,700.707,217.7,700.974,217.853Z",
    transform: "translate(0 0)",
    fill: "#007dba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12897",
    "data-name": "Path 12897",
    d: "M748.348,265.471a4.956,4.956,0,0,1,1.706-.263,5.219,5.219,0,0,1,4.994,3.887,5.114,5.114,0,0,1-.5,3.935,1.421,1.421,0,0,1-1.3.769q-3.25.009-6.5,0a1.444,1.444,0,0,1-1.318-.779,5.254,5.254,0,0,1,.776-6.192c.047-.049.1-.094.158-.151l.586,1.017a9.364,9.364,0,0,0-.541.827,4.024,4.024,0,0,0,.02,3.9.41.41,0,0,0,.424.214q2.843,0,5.685,0c.227,0,.455,0,.682,0a.357.357,0,0,0,.336-.2,4.092,4.092,0,0,0-1.333-5.4,4.031,4.031,0,0,0-3.117-.564.174.174,0,0,1-.228-.1C748.709,266.078,748.532,265.787,748.348,265.471Z",
    transform: "translate(-55.986 -56.016)",
    fill: "#00aafc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12898",
    "data-name": "Path 12898",
    d: "M781.91,278a1.156,1.156,0,0,1-1.065-1.612.269.269,0,0,0-.023-.277q-.977-1.686-1.947-3.376a.584.584,0,1,1,1.006-.584c.286.49.569.982.852,1.474.369.639.738,1.278,1.1,1.919a.249.249,0,0,0,.219.14A1.162,1.162,0,0,1,781.91,278Z",
    transform: "translate(-87.912 -62.213)",
    fill: "#007dba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12899",
    "data-name": "Path 12899",
    d: "M775.357,417.283h3.278a.388.388,0,0,1,.132,0c.059.023.133.052.157.1.016.032-.03.124-.072.152a7.311,7.311,0,0,1-1.075.663,5.707,5.707,0,0,1-5.786-.546c-.094-.065-.227-.2-.212-.271.034-.174.219-.1.339-.1C773.2,417.281,774.277,417.283,775.357,417.283Z",
    transform: "translate(-81.345 -198.696)",
    fill: "#007dba"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnBlockAds);
export default __webpack_public_path__ + "static/media/icn-block-ads.6e874da60166b1cedd7014b9a9192ca5.svg";
export { ForwardRef as ReactComponent };